// ============================================================
// FILE: src/hooks/useSEO.js  →  PAGE TITLES FOR GOOGLE
// Sets each page's browser-tab title and description (SEO).
// Each page calls useSEO("Page Title", "Page description").
// ============================================================

import { useEffect } from "react";

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title;
    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
  }, [title, description]);
}
